import Config from '@/config'
import FlagSA from '@/assets-v4/flags/saudi-arabia-flag.svg?url'
import FlagAE from '@/assets-v4/flags/uae-flag.svg?url'
import FlagKW from '@/assets-v4/flags/kuwait-flag.svg?url'
import FlagQA from '@/assets-v4/flags/qatar-flag.svg?url'
import FlagBH from '@/assets-v4/flags/bahrain-flag.svg?url'
import FlagOM from '@/assets-v4/flags/oman-flag.webp'

import { PAYMENT_METHODS } from '@/constants/payment-methods'

import TermsAndConditionsSauEn from './terms-and-conditions/sau/en'
import TermsAndConditionsSauAr from './terms-and-conditions/sau/ar'
import TermsAndConditionsUaeEn from './terms-and-conditions/uae/en'
import TermsAndConditionsUaeAr from './terms-and-conditions/uae/ar'
import TermsAndConditionsKwtEn from './terms-and-conditions/kwt/en'
import TermsAndConditionsKwtAr from './terms-and-conditions/kwt/ar'
import TermsAndConditionsCashbackEn from './terms-and-conditions-cashback/en'
import TermsAndConditionsCashbackAr from './terms-and-conditions-cashback/ar'
import TermsAndConditionsSubscriptionEn from './terms-and-conditions-subscription/uae/en'
import TermsAndConditionsSubscriptionAr from './terms-and-conditions-subscription/uae/ar'

export default [
  {
    enabled: true,
    isoCode2: 'SA',
    isoCode3: 'SAU',
    countryCode: '966',
    name: 'Saudi Arabia',
    currency: 'SAR',
    currencyDigits: 2,
    phonePattern: /^(9665|05|5)\d{8}$/,
    phoneMaxLength: 10,
    phoneFormatPlaceholder: '5x xxx xxxx',
    phoneBeginWithPattern: [
      {
        beginWith: '9665',
        length: 12,
        pattern: /^9665|٩٦٦٥/,
        maxLength: 12,
      },
      {
        beginWith: '05',
        length: 10,
        pattern: /^05/,
        maxLength: 10,
      },
      {
        beginWith: '5',
        length: 9,
        maxLength: 9,
        pattern: /^5/,
      },
      {
        beginWith: '0',
        length: 1,
        maxLength: 10,
        pattern: /^0$/,
      },
    ],
    supportedPaymentMethods: [
      PAYMENT_METHODS.mada,
      PAYMENT_METHODS.applePay,
      PAYMENT_METHODS.masterCard,
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.amex,
    ],
    applePaySupportedNetworks: [
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
      PAYMENT_METHODS.mada,
      PAYMENT_METHODS.amex,
    ],
    flagImage: FlagSA,
    ckoPublicKey: Config.checkoutGatewayPublicKeyForSAU,
    ckoPublicKeyV2: Config.checkoutGatewayPublicKeyForSAUV2,
    termsAndConditions: {
      ar: TermsAndConditionsSauAr,
      en: TermsAndConditionsSauEn,
    },
    termsAndConditionsCashback: {
      ar: TermsAndConditionsCashbackAr,
      en: TermsAndConditionsCashbackEn,
    },
    supportAutoCharge: true,
  },
  {
    enabled: true,
    isoCode2: 'AE',
    isoCode3: 'ARE',
    countryCode: '971',
    name: 'United Arab Emirates',
    currency: 'AED',
    currencyDigits: 2,
    phonePattern: /^(9715|05|5)\d{8}$/,
    phoneMaxLength: 10,
    phoneFormatPlaceholder: '5x xxx xxxx',
    phoneBeginWithPattern: [
      {
        beginWith: '9715',
        length: 12,
        pattern: /^9715|٩٧١٥/,
        maxLength: 12,
      },
      {
        beginWith: '05',
        length: 10,
        pattern: /^05/,
        maxLength: 10,
      },
      {
        beginWith: '5',
        length: 9,
        maxLength: 9,
        pattern: /^5/,
      },
      {
        beginWith: '0',
        length: 1,
        maxLength: 10,
        pattern: /^0$/,
      },
    ],
    supportedPaymentMethods: [
      PAYMENT_METHODS.applePay,
      PAYMENT_METHODS.masterCard,
      PAYMENT_METHODS.visa,
    ],
    applePaySupportedNetworks: [
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
    ],
    flagImage: FlagAE,
    ckoPublicKey: Config.checkoutGatewayPublicKeyForARE,
    ckoPublicKeyV2: Config.checkoutGatewayPublicKeyForAREV2,
    termsAndConditions: {
      ar: TermsAndConditionsUaeAr,
      en: TermsAndConditionsUaeEn,
    },
    termsAndConditionsCashback: {
      ar: TermsAndConditionsCashbackAr,
      en: TermsAndConditionsCashbackEn,
    },
    termsAndConditionsSubscription: {
      ar: TermsAndConditionsSubscriptionAr,
      en: TermsAndConditionsSubscriptionEn,
    },
    supportAutoCharge: false,
  },
  {
    enabled: true,
    isoCode2: 'KW',
    isoCode3: 'KWT',
    countryCode: '965',
    name: 'Kuwait',
    currency: 'KWD',
    currencyDigits: 3,
    phonePattern: /^(02|04|05|06|09|2|4|5|6|9)\d{7}$/,
    phoneMaxLength: 9,
    phoneFormatPlaceholder: '5x xxx xxx',
    phoneBeginWithPattern: [
      {
        beginWith: '02',
        length: 9,
        pattern: /^(0[24569])/,
        maxLength: 9,
      },
      {
        beginWith: '2',
        length: 8,
        maxLength: 8,
        pattern: /^[24569]/,
      },
      {
        beginWith: '04',
        length: 9,
        pattern: /^(0[24569])/,
        maxLength: 9,
      },
      {
        beginWith: '4',
        length: 8,
        maxLength: 8,
        pattern: /^[24569]/,
      },
      {
        beginWith: '05',
        length: 9,
        pattern: /^(0[24569])/,
        maxLength: 9,
      },
      {
        beginWith: '5',
        length: 8,
        maxLength: 8,
        pattern: /^[24569]/,
      },
      {
        beginWith: '06',
        length: 9,
        pattern: /^(0[24569])/,
        maxLength: 9,
      },
      {
        beginWith: '6',
        length: 8,
        maxLength: 8,
        pattern: /^[24569]/,
      },
      {
        beginWith: '09',
        length: 9,
        pattern: /^(0[24569])/,
        maxLength: 9,
      },
      {
        beginWith: '9',
        length: 8,
        maxLength: 8,
        pattern: /^[24569]/,
      },
      {
        beginWith: '0',
        length: 1,
        maxLength: 9,
        pattern: /^0$/,
      },
    ],
    supportedPaymentMethods: [
      PAYMENT_METHODS.knet,
      PAYMENT_METHODS.masterCard,
      PAYMENT_METHODS.visa,
    ],
    applePaySupportedNetworks: [
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
    ],
    flagImage: FlagKW,
    ckoPublicKey: Config.checkoutGatewayPublicKeyForKWD,
    ckoPublicKeyV2: Config.checkoutGatewayPublicKeyForKWDV2,
    termsAndConditions: {
      ar: TermsAndConditionsKwtAr,
      en: TermsAndConditionsKwtEn,
    },
    termsAndConditionsCashback: {
      ar: TermsAndConditionsCashbackAr,
      en: TermsAndConditionsCashbackEn,
    },
    supportAutoCharge: false,
  },
  {
    enabled: true,
    isoCode2: 'QA',
    isoCode3: 'QAT',
    countryCode: '974',
    name: 'Qatar',
    currency: 'QAR',
    currencyDigits: 2,
    phonePattern: /^(03|05|06|07|3|5|6|7)\d{7}$/,
    phoneMaxLength: 9,
    phoneFormatPlaceholder: '5x xxx xxx',
    phoneBeginWithPattern: [
      {
        beginWith: '05',
        length: 9,
        pattern: /^(0[3567])/,
        maxLength: 9,
      },
      {
        beginWith: '5',
        length: 8,
        maxLength: 8,
        pattern: /^[3567]/,
      },
      {
        beginWith: '0',
        length: 1,
        maxLength: 9,
        pattern: /^0$/,
      },
    ],
    supportedPaymentMethods: [
      PAYMENT_METHODS.applePay,
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
    ],
    applePaySupportedNetworks: [
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
    ],
    flagImage: FlagQA,
    ckoPublicKey: Config.checkoutGatewayPublicKeyForQAR,
    ckoPublicKeyV2: Config.checkoutGatewayPublicKeyForQARV2,
    termsAndConditions: {
      ar: TermsAndConditionsSauAr,
      en: TermsAndConditionsSauEn,
    },
    termsAndConditionsCashback: {
      ar: TermsAndConditionsCashbackAr,
      en: TermsAndConditionsCashbackEn,
    },
    supportAutoCharge: false,
  },
  {
    enabled: true,
    isoCode2: 'BH',
    isoCode3: 'BHR',
    countryCode: '973',
    name: 'Bahrain',
    currency: 'BHD',
    currencyDigits: 3,
    phonePattern: /^(03|3|66)\d{6,7}$/,
    phoneMaxLength: 9,
    phoneFormatPlaceholder: '3x xxx xxx',
    phoneBeginWithPattern: [
      {
        beginWith: '03',
        length: 9,
        pattern: /^(03)/,
        maxLength: 9,
      },
      {
        beginWith: '3',
        length: 8,
        maxLength: 8,
        pattern: /^3/,
      },
      {
        beginWith: '0',
        length: 1,
        maxLength: 9,
        pattern: /^0$/,
      },
      {
        beginWith: '66',
        length: 8,
        maxLength: 9,
        pattern: /^66/,
      },
    ],
    supportedPaymentMethods: [
      PAYMENT_METHODS.applePay,
      PAYMENT_METHODS.benefit,
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
    ],
    applePaySupportedNetworks: [
      PAYMENT_METHODS.visa,
      PAYMENT_METHODS.masterCard,
    ],
    flagImage: FlagBH,
    ckoPublicKey: Config.checkoutGatewayPublicKeyForBHD,
    ckoPublicKeyV2: Config.checkoutGatewayPublicKeyForBHDV2,
    termsAndConditions: {
      ar: TermsAndConditionsSauAr,
      en: TermsAndConditionsSauEn,
    },
    termsAndConditionsCashback: {
      ar: TermsAndConditionsCashbackAr,
      en: TermsAndConditionsCashbackEn,
    },
    supportAutoCharge: false,
  },
  {
    enabled: true,
    isoCode2: 'OM',
    isoCode3: 'OMN',
    countryCode: '968',
    name: 'Oman',
    currency: 'OMR',
    currencyDigits: 3,
    phonePattern: /^0?(2|7|9)\d{7}$/,
    phoneMaxLength: 9,
    phoneFormatPlaceholder: 'xxxx xxxx',
    phoneBeginWithPattern: [
      {
        beginWith: '[279]',
        length: 8,
        pattern: /^[279]/,
        maxLength: 8,
      },
      {
        beginWith: '0[2279]',
        length: 9,
        pattern: /^0[279]/,
        maxLength: 9,
      },
      {
        beginWith: '0x',
        length: 2,
        maxLength: 9,
        pattern: /^0[279]$/,
      },
      {
        beginWith: '0',
        length: 1,
        maxLength: 9,
        pattern: /^0$/,
      },
    ],
    supportedPaymentMethods: [PAYMENT_METHODS.visa, PAYMENT_METHODS.masterCard],
    applePaySupportedNetworks: [],
    flagImage: FlagOM,
    ckoPublicKey: Config.checkoutGatewayPublicKeyForOMN,
    ckoPublicKeyV2: Config.checkoutGatewayPublicKeyForOMNV2,
    termsAndConditions: {
      ar: TermsAndConditionsSauAr,
      en: TermsAndConditionsSauEn,
    },
    termsAndConditionsCashback: {
      ar: TermsAndConditionsCashbackAr,
      en: TermsAndConditionsCashbackEn,
    },
    supportAutoCharge: false,
  },
]
